import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class ExtensionService extends ServiceCRUD {
  constructor() {
    super('/api/bosssecretary');
  }
}

export default new ExtensionService();
